module.exports = __webpack_public_path__ + "media/application/images/svgs/bell-7b2b11d782af88095e7f1cf8c8229182.svg";